import { render } from "./progress-bar.vue?vue&type=template&id=0ce3226b"
import script from "./progress-bar.vue?vue&type=script&lang=js"
export * from "./progress-bar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PC\\Codebase\\390labs\\Coverage\\legacycomposer.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__